export const TOKEN_STORAGE_KEY = 'token';
export const USER_INFO_STORAGE_KEY = 'userInfo';

export function getToken() {
  return localStorage.getItem(TOKEN_STORAGE_KEY);
}

export function getUserInfo() {
  try {
    const raw = localStorage.getItem(USER_INFO_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(USER_INFO_STORAGE_KEY);
}

/**
 * Декодирует payload JWT без библиотеки jwt-decode.
 */
export function parseJwt(token) {
  if (!token) return null;

  try {
    const parts = token.split('.');

    if (parts.length !== 3) {
      return null;
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(
          (c) =>
            '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        )
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

/**
 * Проверяет, истёк ли JWT.
 *
 * @param {string | null} token
 * @param {number} bufferSeconds - запас времени, чтобы не ждать прямо до последней секунды
 */
export function isTokenExpired(token, bufferSeconds = 30) {
  if (!token) {
    return true;
  }

  const payload = parseJwt(token);

  if (!payload) {
    return true;
  }

  if (typeof payload.exp !== 'number') {
    return true;
  }

  const expiresAtMs = payload.exp * 1000;
  const nowWithBufferMs = Date.now() + bufferSeconds * 1000;

  return nowWithBufferMs >= expiresAtMs;
}

export function isAuthenticated() {
  const token = getToken();

  return Boolean(token) && !isTokenExpired(token);
}

export function redirectToLogin() {
  clearAuth();

  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
}